var modules_b2eef00e = {"subtitle":"Subtitles_module_subtitle__65ce90c5"};
import "../../../../assets/esm/components/OfferCard/components/Subtitles/Subtitles~D5U0diuf.css";

export { modules_b2eef00e as default };
//# sourceMappingURL=Subtitles.module.scss.js.map
